import { call, put, takeEvery } from "redux-saga/effects"

import { GET_APP_INFO, GET_CURRENCIES, GET_CITIES, GET_COMM_CHANNELS, GET_MUNICIPALITIES } from "./actionTypes"

import {
  getAppInfoFail,
  getAppInfoSuccess,
  getCurrenciesSuccess,
  getCurrenciesFail,
  getCitiesSuccess,
  getCitiesFail,
  getCommChannelsSuccess,
  getCommChannelsFail,
  getMunicipalitiesSuccess,
  getMunicipalitiesFail,
} from "./actions"
import { appInitLookup, getCurrencies, getCities, getCommChannels, getMunicipalities } from "helpers/backend_helper"

function* getAppInfo({ payload }) {
  try {
    const response = yield call(appInitLookup, payload)
    yield put(getAppInfoSuccess(response))
  } catch (error) {
    yield put(getAppInfoFail(error))
  }
}

function* fetchCurrencies({ payload: { options, history } }) {
  try {
    const response = yield call(getCurrencies, options)
    yield put(getCurrenciesSuccess(response))
  } catch (error) {
    yield put(getCurrenciesFail(error))
  }
}

function* fetchCities({ payload: { options, history } }) {
  try {
    const response = yield call(getCities, options)
    yield put(getCitiesSuccess(response))
  } catch (error) {
    yield put(getCitiesFail(error))
  }
}

function* fetchCommChannels({ payload: { options, history } }) {
  try {
    const response = yield call(getCommChannels, options)
    yield put(getCommChannelsSuccess(response))
  } catch (error) {
    yield put(getCommChannelsFail(error))
  }
}

function* fetchMunicipalities({ payload: { options, history } }) {
  try {
    const response = yield call(getMunicipalities, options)
    yield put(getMunicipalitiesSuccess(response))
  } catch (error) {
    yield put(getMunicipalitiesFail(error))
  }
}

function* appInfoSaga() {
  yield takeEvery(GET_APP_INFO, getAppInfo)
  yield takeEvery(GET_CURRENCIES, fetchCurrencies)
  yield takeEvery(GET_CITIES, fetchCities)
  yield takeEvery(GET_COMM_CHANNELS, fetchCommChannels)
  yield takeEvery(GET_MUNICIPALITIES, fetchMunicipalities)
}

export default appInfoSaga
